import { useEffect, useState } from "react";
import { FileText, LockKeyhole, RefreshCw } from "lucide-react";
import api, { errMsg } from "../lib/api";
import { toast } from "sonner";

export const VocFeatures = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/voc/features").then(r => { setData(r.data); setError(""); }).catch(e => setError(errMsg(e)));
  useEffect(() => { load(); const timer = setInterval(load, 15000); return () => clearInterval(timer); }, []);
  const sync = async () => {
    setBusy(true);
    try { await api.post("/voc/transcripts/sync"); toast.success("New-call transcription check queued"); await load(); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };
  return <div className="space-y-5 py-4" data-testid="voc-features">
    {error && <p role="alert" className="text-sm text-destructive" data-testid="voc-features-error">{error}</p>}
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <h3 className="font-semibold flex items-center gap-2"><FileText size={17} /> Call transcripts</h3>
        <p className="text-sm text-muted-foreground mt-1" data-testid="transcript-sync-status">{data?.connected ? "Automatic · new calls only" : "VOCPhone connection required"}</p>
        {data?.transcript_enabled_at && <p className="text-xs text-muted-foreground mt-1" data-testid="transcript-cutoff">From {new Date(data.transcript_enabled_at).toLocaleString("en-AU")}</p>}
        {data && <p className="text-xs text-muted-foreground mt-1" data-testid="transcript-counts">{data.transcript_imported} imported · {data.transcript_pending} pending · {data.transcript_errors} awaiting retry</p>}
      </div>
      <button type="button" onClick={sync} disabled={!data?.connected || busy || data?.running} data-testid="sync-new-transcripts"
        className="inline-flex items-center gap-2 px-3 py-2 rounded-md border border-border text-sm font-semibold hover:bg-muted disabled:opacity-50">
        <RefreshCw size={15} className={busy || data?.running ? "animate-spin" : ""} /> Check now
      </button>
    </div>
    <div role="status" className="border-t border-border pt-4" data-testid="private-contacts-blocked">
      <h3 className="font-semibold flex items-center gap-2"><LockKeyhole size={17} /> Private contact sync — awaiting Uniden access</h3>
      <p className="text-sm text-muted-foreground mt-1">{data?.contact_reason || "Owner-private phonebook access must be verified. No contacts are exported."}</p>
    </div>
  </div>;
};